export const COBRANDED_USEFUL_PHONES_RAW_RESULT = {
  id: 'ecad1cb5-9166-4330-9afa-3348117315eb',
  content: {
    bb: {
      content: {
        bbtel:
          '<p><span style="font-size: 12px;"><strong>Central de Atendimento:</strong><br><br>Platinum - 4003 0151 (capitais e regiões metropolitanas) e 0800 729 2329 (demais localidades)<br><br>Gold e Internacional - 4004 0001 (capitais e regiões metropolitanas) e 0800 729 0001 (demais localidades)<br><br>Horário de atendimento: 24h todos os dias da semana.</span></p>\n',
        bbsmiles:
          '<p><span style="font-size: 12px;"><strong>Smiles e Prata:</strong> 0300 115 7001<br>Horário de atendimento 06h - 00h<br><br><strong>Diamante e Ouro: </strong>0300 115 7007<br>Horário de atendimento 24h<br><br><strong>Atendimento a Deficientes Auditivos: </strong>0800 709 0466</span></p>\n',
      },
    },
    santander: {
      content: {
        santandertel:
          '<p><span style="font-size: 12px;"><strong>Central de Atendimento:</strong> 4004 3535 / 0800 720 3535 / <strong>Demais localidades:</strong> 0800 723 5007<br><br><strong>Pessoas com deficiência auditiva e fala:</strong> 0800 723 5007<br>Consultas, informações e transações.<br><br><strong>SAC: </strong>0800 762 7777<br><br><strong>SAC - Ligações Exterior (a cobrar):</strong> +55 11 3012-3336<br><br><strong>SAC - Deficiência Auditiva ou de Fala:</strong> 0800 771 0401<br><br><strong>Ouvidoria:</strong> 0800 726 0322<br><br><strong>Ouvidoria Pessoas com deficiência auditiva e de fala: </strong>0800 771 0301 Atendimento das 09h às 18h, de 2ª a 6ª, exceto feriados.</span></p>\n',
        santandersmiles:
          '<p><span style="font-size: 12px;"><strong>Smiles e Prata:</strong> 0300 115 7001<br>Horário de atendimento 06h - 00h<br><br><strong>Diamante e Ouro: </strong>0300 115 7007<br>Horário de atendimento 24h<br><br><strong>Atendimento a Deficientes Auditivos: </strong>0800 709 0466</span></p>\n',
      },
    },
    bradesco: {
      content: {
        bradescotel:
          '<p><span style="font-size: 12px;"><strong>Central de Atendimento:</strong> 4004 1333 / 0800 725 8510 Atendimento 24 horas, 7 dias por semana. Consultas, informações e serviços transacionais.</span><br><br><span style="font-size: 12px;"><strong>Acesso ao Exterior: </strong>55 11 4003 1333</span><br><br><span style="font-size: 12px;"><strong>SAC - Bradesco Cartões:</strong> 0800 727 9988</span><br><br><span style="font-size: 12px;"><strong>SAC - Deficiência Auditiva ou de Fala: </strong>0800 722 0099</span><br><br><span style="font-size: 12px;"><strong>Ouvidoria: </strong>0800 727 9933</span><br><span style="font-size: 12px;">Atendimento das 09h às 18h, de 2ª a 6ª, exceto feriados.</span></p>\n',
        bradescosmiles:
          '<p><span style="font-size: 12px;"><strong>Smiles e Prata:</strong> 0300 115 7001<br>Horário de atendimento 06h - 00h<br><br><strong>Diamante e Ouro:</strong> 0300 115 7007<br>Horário de atendimento 24h<br><br><strong>Atendimento a Deficientes Auditivos:</strong> 0800 709 0466</span></p>\n',
      },
    },
  },
};

export const COBRANDED_USEFUL_PHONES_REFINED_RESULT = [
  {
    type: 'BB',
    phoneList: {
      bank: [
        {
          title: 'Central de Atendimento:',
          text: 'Platinum - 4003 0151 (capitais e regiões metropolitanas) e 0800 729 2329 (demais localidades)<br><br>Gold e Internacional - 4004 0001 (capitais e regiões metropolitanas) e 0800 729 0001 (demais localidades)<br><br>Horário de atendimento: 24h todos os dias da semana.',
        },
      ],
      smiles: [
        {
          title: 'Smiles e Prata:',
          text: '0300 115 7001<br>Horário de atendimento 06h - 00h',
        },
        {
          title: 'Diamante e Ouro:',
          text: '0300 115 7007<br>Horário de atendimento 24h',
        },
        {
          title: 'Atendimento a Deficientes Auditivos:',
          text: '0800 709 0466',
        },
      ],
    },
  },
  {
    type: 'SANTANDER',
    phoneList: {
      bank: [
        {
          title: 'Central de Atendimento:',
          text: '4004 3535 / 0800 720 3535 /',
        },
        { title: 'Demais localidades:', text: '0800 723 5007' },
        {
          title: 'Pessoas com deficiência auditiva e fala:',
          text: '0800 723 5007<br>Consultas, informações e transações.',
        },
        { title: 'SAC:', text: '0800 762 7777' },
        {
          title: 'SAC - Ligações Exterior (a cobrar):',
          text: '+55 11 3012-3336',
        },
        {
          title: 'SAC - Deficiência Auditiva ou de Fala:',
          text: '0800 771 0401',
        },
        { title: 'Ouvidoria:', text: '0800 726 0322' },
        {
          title: 'Ouvidoria Pessoas com deficiência auditiva e de fala:',
          text: '0800 771 0301 Atendimento das 09h às 18h, de 2ª a 6ª, exceto feriados.',
        },
      ],
      smiles: [
        {
          title: 'Smiles e Prata:',
          text: '0300 115 7001<br>Horário de atendimento 06h - 00h',
        },
        {
          title: 'Diamante e Ouro:',
          text: '0300 115 7007<br>Horário de atendimento 24h',
        },
        {
          title: 'Atendimento a Deficientes Auditivos:',
          text: '0800 709 0466',
        },
      ],
    },
  },
  {
    type: 'BRADESCO',
    phoneList: {
      bank: [
        {
          title: 'Central de Atendimento:',
          text: '4004 1333 / 0800 725 8510 Atendimento 24 horas, 7 dias por semana. Consultas, informações e serviços transacionais.',
        },
        {
          title: 'Acesso ao Exterior:',
          text: '55 11 4003 1333',
        },
        {
          title: 'SAC - Bradesco Cartões:',
          text: '0800 727 9988',
        },
        {
          title: 'SAC - Deficiência Auditiva ou de Fala:',
          text: '0800 722 0099',
        },
        {
          title: 'Ouvidoria:',
          text: '0800 727 9933<br>Atendimento das 09h às 18h, de 2ª a 6ª, exceto feriados.',
        },
      ],
      smiles: [
        {
          title: 'Smiles e Prata:',
          text: '0300 115 7001<br>Horário de atendimento 06h - 00h',
        },
        {
          title: 'Diamante e Ouro:',
          text: '0300 115 7007<br>Horário de atendimento 24h',
        },
        {
          title: 'Atendimento a Deficientes Auditivos:',
          text: '0800 709 0466',
        },
      ],
    },
  },
];
